import React from "react";
import { Text, View } from "react-native";
import { Link, useRouter } from "expo-router";
import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";
import * as z from "zod";

import { Logo } from "~/components/Logo";
import { PageMeta } from "~/components/PageMeta";
import { supabaseClient } from "~/lib/supabase";
import { email } from "~/lib/validation";
import { Button } from "~/ui/Button";
import { Form } from "~/ui/Form";
import { TextInput } from "~/ui/TextInput";

const loginFormSchema = z.object({
  email,
  password: z.string(),
});

export default function LoginWithEmail() {
  const { replace } = useRouter();
  const [error, setError] = React.useState<string | null>(null);

  const { control, handleSubmit, formState } = useForm<
    z.infer<typeof loginFormSchema>
  >({
    resolver: zodResolver(loginFormSchema),
    defaultValues: {
      email: "",
      password: "",
    },
  });

  function onSubmit(data: z.infer<typeof loginFormSchema>) {
    setError(null);
    return supabaseClient.auth
      .signInWithPassword(data)
      .then((response) => {
        console.log({ response });
        if (response.error) {
          setError(response.error.message);
        } else {
          replace("/");
        }
      })
      .catch((e) => console.error(e));
  }

  return (
    <View className="container mb-32 max-w-96 flex-grow items-stretch justify-center gap-10 p-6">
      <PageMeta title="Login with email" />
      <View className="items-center space-y-6">
        <Logo className="w-12" />
        <Text className="text-text-primary text-28 font-semibold">
          Login with email
        </Text>
      </View>
      <Form onSubmit={handleSubmit(onSubmit)} className="gap-4">
        <Controller
          control={control}
          name="email"
          render={({ field, fieldState: { error } }) => (
            <TextInput
              autoFocus
              label="Email"
              placeholder="johndoe@example.com"
              onChangeText={field.onChange}
              value={field.value}
              keyboardType="email-address"
              errorMessage={error?.message}
            />
          )}
        />
        <View className="gap-2">
          <Controller
            control={control}
            name="password"
            render={({ field, fieldState: { error } }) => (
              <TextInput
                label="Password"
                placeholder="Password123"
                onChangeText={field.onChange}
                value={field.value}
                secureTextEntry
                autoCapitalize="none"
                autoComplete="off"
                keyboardType="visible-password"
                errorMessage={error?.message}
              />
            )}
          />

          <View className="flex-row items-center justify-end">
            <Link asChild href="/auth/recovery">
              <Text className="text-text-secondary">Forgot your password?</Text>
            </Link>
          </View>
        </View>
        {error && <Text className="text-red-500">{error}</Text>}
        <Button
          role="button"
          onPress={handleSubmit(onSubmit)}
          isLoading={formState.isSubmitting}
          className="mt-6"
        >
          Login
        </Button>
      </Form>
    </View>
  );
}
